<template>
  <div
    v-if="
      stepsList.length ||
        operationBtnList.length ||
        (caseInfo.taskIsShow == true && taskCode != '') || // 子任务判断
        (caseInfo.flowCode != 103001 && caseInfo.flowCode != 103501 && caseInfo.isStation == true) // 中转任务判断
    "
    class="process-content"
  >
    <el-card class="content-block">
      <div slot="header" class="clearfix">
        <span class="bold">流程功能区</span>
      </div>
      <div class="item-block">
        <template v-if="checkPermission('流程功能区:查看', permList)">
          <!-- 当前流程的步骤条 -->
          <el-steps
            :active="stepsActiveIndex"
            process-status="wait"
            finish-status="success"
            :space="185"
            :align-center="false"
          >
            <el-step v-for="item in stepsList" :key="item.flowCode" :title="item.title" />
          </el-steps>
        </template>

        <!-- 操作功能 -->
        <div class="button-block">
          <!-- 时间选择器 -->
          <div v-if="isPickerBlock" class="marginTop20">
            <el-date-picker
              v-model="startDeadlineTime"
              type="date"
              :readonly="true"
              disabled
              placeholder="开始不予互助时间"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
            />
            <span style="margin: 0px 8px">-</span>
            <el-date-picker
              v-model="endDeadlineTime"
              type="date"
              placeholder="超时不予互助时间"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
            />
          </div>

          <div
            v-if="checkPermission('复审:合议', permList) && caseInfo.flowCode == 101540"
            class="marginTop20"
          >
            <el-input
              v-model="collegiateResult"
              type="textarea"
              :autosize="{ minRows: 5, maxRows: 10 }"
              placeholder="合议内容"
            />
          </div>

          <div
            v-if="checkPermission('交叉审:合议', permList) && caseInfo.flowCode == 101740"
            class="marginTop20"
          >
            <el-input
              v-model="perms"
              type="textarea"
              :autosize="{ minRows: 5, maxRows: 10 }"
              placeholder="合议内容"
            />
          </div>

          <div v-if="isBackRemarkInput" class="marginTop20">
            <el-input
              v-model="backRemark"
              type="textarea"
              :autosize="{ minRows: 5, maxRows: 10 }"
              placeholder="退回必填"
            />
          </div>

          <!-- 遍历对应流程的操作按钮列表 -->
          <div v-if="operationBtnList && operationBtnList.length && checkPermission('流程功能区:编辑', permList)" class="marginTop20">
            <template v-for="(item, index) in operationBtnList">
              <el-button
                :key="index"
                v-loading.fullscreen.lock="fullscreenLoading"
                size="small"
                :type="item.type || 'primary'"
                :icon="item.icon || 'el-icon-edit-outline'"
                element-loading-text="正在加载，请耐心等待！"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.1)"
                @click="onOperationBtnMethod(item.methodName, item.methodParams)"
              >
                {{ item.name }}
              </el-button>
            </template>
          </div>

          <!-- 子任务 -->
          <div
            v-if="
              checkPermission('子任务:处理任务', permList) &&
                caseInfo.taskIsShow == true &&
                taskCode != ''
            "
            class="marginTop20"
          >
            <!-- 如果当前页面来源于“全部任务”或者“我的任务”，则显示“未接通”和“未完成”的操作按钮 -->
            <template v-if="currentfrom === 'task' || currentfrom === 'mytask'">
              <el-button
                size="small"
                type="primary"
                icon="el-icon-edit-outline"
                @click="updateTask('MISSED_CALL', '未接通')"
              >
                未接通
              </el-button>
              <el-button
                size="small"
                type="primary"
                icon="el-icon-edit-outline"
                @click="updateTask('UNDONE', '未完成')"
              >
                未完成
              </el-button>
            </template>

            <el-button
              size="small"
              type="primary"
              icon="el-icon-edit-outline"
              @click="updateTask('SKIP', '跳过')"
            >
              跳过
            </el-button>
            <el-button
              size="small"
              type="primary"
              icon="el-icon-edit-outline"
              @click="updateTask('DONE', '已完成')"
            >
              已完成
            </el-button>
          </div>

          <!-- 中转站 -->
          <div
            v-if="
              checkPermission('案件中转站:移动案件', permList) &&
                caseInfo.flowCode != 103001 &&
                caseInfo.flowCode != 103501 &&
                caseInfo.isStation == true
            "
            class="marginTop20"
          >
            <el-button
              size="small"
              type="primary"
              icon="el-icon-edit-outline"
              @click="showdrawerbox('removeStation')"
            >
              取消中转
            </el-button>
            <el-button
              size="small"
              type="primary"
              icon="el-icon-edit-outline"
              @click="showdrawerbox('jumpFlow')"
            >
              跳到指定流程
            </el-button>
            <el-button
              size="small"
              type="primary"
              icon="el-icon-edit-outline"
              @click="showdrawerbox('repealCase')"
            >
              撤案
            </el-button>
            <el-button
              size="small"
              type="primary"
              icon="el-icon-edit-outline"
              @click="showdrawerbox('toFile')"
            >
              不予互助
            </el-button>
          </div>

          <!-- 案件超期处理 -->
          <div
            v-if="
              caseInfo.overTimeShowWithdrawFlag == true ||
                caseInfo.overTimeShowRefuseFlag == true
            "
            class="marginTop20"
          >
            <!-- 有不予互助的时候，不显示撤案 -->
            <el-button
              v-if="
                checkPermission('案件超期处理:撤案', permList) &&
                  caseInfo.overTimeShowWithdrawFlag == true &&
                  caseInfo.overTimeShowRefuseFlag != true
              "
              size="small"
              type="primary"
              icon="el-icon-edit-outline"
              @click="updateFlow(operateEnums.WITHDRAWAL, '案件超期处理,撤案')"
            >
              撤案
            </el-button>
            <el-button
              v-if="
                checkPermission('案件超期处理:不予互助', permList) &&
                  caseInfo.overTimeShowRefuseFlag == true
              "
              size="small"
              type="primary"
              icon="el-icon-edit-outline"
              @click="updateFlow(operateEnums.REFUSAL, '案件超期处理,不予互助')"
            >
              不予互助
            </el-button>
          </div>
        </div>
      </div>
    </el-card>

    <el-dialog
      title="发送邮件"
      :visible.sync="emailDialog"
      width="90%"
      custom-class="c-p"
    >
      <v-sendEmail
        :case-code="caseInfo.caseCode"
        :version="caseInfo.infoVersion"
        :cases="caseInfo"
        :update-t="showButton"
        :show-email-tab="showEmailTab"
        :show-email-msg="showEmailMsg"
        :show-email-code="showEmailCode"
        :is-refresh-btn="false"
        @updateFlow="updateCaseFlow"
        @getcaseInfo="getCaseInfo"
      />
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SendEmail from '@/pages/email/SendEmail.vue' // 发送邮件

export default {
  name: 'ProcessFunction',
  components: {
    'v-sendEmail': SendEmail
  },

  props: {
    // 任务编号
    taskCode: {
      type: String,
      default: () => {
        return ''
      }
    },
    // 任务版本
    taskVersion: {
      type: String,
      default: () => {
        return ''
      }
    },
    // 回答规则结果
    answerRuleResult: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  data() {
    return {
      stepsList: [], // 当前步骤列表
      stepsActiveIndex: 0, // 当前步骤已完成的下标值
      // 所有流程的步骤列表
      allStepsList: {
        // 初审
        1000: [
          {
            title: '核查报案信息',
            flowCode: '100001'
          },
          {
            title: '事件内容评估',
            flowCode: '100005'
          },
          {
            title: '回访并通知邮寄材料',
            flowCode: '100010'
          },
          {
            title: '纸质材料处理',
            flowCode: '100030'
          },
          {
            title: '核对材料',
            flowCode: '100035'
          },
          {
            title: '审核补充资料',
            flowCode: '100055'
          },
          {
            title: '输出初审结果',
            flowCode: '100060'
          }
        ],
        // 缴费
        1005: [
          {
            title: '确定去调查',
            flowCode: '100599'
          },
          {
            title: '邮件通知立案',
            flowCode: '100501'
          },
          {
            title: '通知及确认缴费',
            flowCode: '100505'
          }
        ],
        // 公估
        1010: [
          {
            title: '委派公估',
            flowCode: '101005'
          },
          {
            title: '接单确认',
            flowCode: '101010'
          },
          {
            title: '回访',
            flowCode: '101015'
          },
          {
            title: '上传公估结果',
            flowCode: '101020'
          }
        ],
        // 复审
        1015: [
          {
            title: '事件内容评估',
            flowCode: '101501'
          },
          {
            title: '审核公估调查内容',
            flowCode: '101505'
          },
          {
            title: '通知并查收补充资料',
            flowCode: '101510'
          },
          {
            title: '输出复审结果',
            flowCode: '101535'
          },
          {
            title: '输出审批结果',
            flowCode: '101550'
          },
          {
            title: '输出三审结果',
            flowCode: '101560'
          },
          {
            title: '已审批',
            flowCode: '101570'
          }
        ],
        // 交叉审
        1017: [
          {
            title: '事件内容评估',
            flowCode: '101701'
          },
          {
            title: '审核公估调查内容',
            flowCode: '101705'
          },
          {
            title: '通知并查收补充资料',
            flowCode: '101710'
          },
          {
            title: '输出复审结果',
            flowCode: '101735'
          }
        ],
        // 待公示
        1020: [
          {
            title: '邮件告知用户',
            flowCode: '102001'
          },
          {
            title: '确认已缴费',
            flowCode: '102005'
          },
          {
            title: '查收公证材料',
            flowCode: '102010'
          },
          {
            title: '核对银行账号',
            flowCode: '102015'
          },
          {
            title: '回收调查意见表',
            flowCode: '102030'
          },
          {
            title: '确认已完成助力',
            flowCode: '102035'
          },
          {
            title: '进入业管端',
            flowCode: '102070'
          }
        ],
        // 可公示
        1025: [
          {
            title: '邮件通知用户进入公示期',
            flowCode: '102501'
          },
          {
            title: '扣款',
            flowCode: '102505'
          },
          {
            title: '收取收据',
            flowCode: '102510'
          }
        ],
        // 待归档：确认结果（待归档）
        103001: [
          {
            title: '邮件告知用户结果',
            flowCode: '103001',
            judge: true // 标识当前流程需要单独增加判断
          },
          {
            title: '确认归档',
            flowCode: '103001',
            judge: true // 标识当前流程需要单独增加判断
          }
        ],
        // 待归档：合议
        103050: [
          {
            title: '去法务',
            flowCode: '103050'
          }
        ],
        // 待归档：法务
        103075: [
          {
            title: '去归档',
            flowCode: '103075'
          }
        ],
        // 归档
        1035: [
          {
            title: '退回到合议',
            flowCode: '103501',
            judge: true // 标识当前流程需要单独增加判断
          }
        ]
      },

      operationBtnList: [], // 当前案件的操作流程按钮列表
      startDeadlineTime: null, // 超时不予互助时使用的时间-开始时间
      endDeadlineTime: null, // 超时不予互助时使用的时间-结束时间
      collegiateResult: '', // 复审:合议  合议内容
      perms: '', // 交叉审:合议  合议内容
      backRemark: '', // 待公示:退回  退回内容

      // 发送邮件
      emailDialog: false, // 控制发送邮件抽屉是否显示
      showEmailTab: [],
      showEmailMsg: '',
      showEmailCode: 0,
      showButton: false,

      // 操作枚举
      operateEnums: {
        WITHDRAWAL: 1, // 撤案
        REFUSAL: 2, // 不予互助
        PREVIOUSFLOW: 4, // 上一步
        CASEGOBACK: 8, // 回退
        APPLICATION_COLLEGIATE: 16, // 申请合议
        NEXTSTEP: 32, // 下一步
        RESTARTCASE: 64, // 重新发起
        CYCLE: 128, // 循环
        UNOPERATING: 256, // 不做操作
        OVERTIME_RETURN: 512 // 超时退回
      },

      fullscreenLoading: false,
      // 全部操作流程-按钮列表
      allOperationBtnList: {
        // 初审
        1000: [
          {
            permName: '初审:核查报案信息',
            flowCode: 100001,
            children: [
              {
                name: '下一步', // 按钮名称
                type: '', // 按钮类型（参考Element Buttom 类型）
                icon: '', // 按钮Icon
                isHadPrevBtn: false, // 是否需要判断当前流程，是否为“上一步”的按钮
                methodName: 'updateFlow', // 点击事件-方法名
                methodParams: ['NEXTSTEP', '报案信息已核'] // 点击事件-参数
              }
            ]
          },
          {
            permName: '初审:事件内容评估',
            flowCode: 100005,
            children: [
              {
                name: '下一步',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['NEXTSTEP', '事件内容评估']
              }
            ]
          },
          {
            permName: '初审:回访并通知邮寄材料:发邮件',
            flowCode: 100015,
            children: [
              {
                name: '发提交材料邮件',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['NEXTSTEP', '发提交材料邮件']
              }
            ]
          },
          {
            permName: '初审:回访并通知邮寄材料:回访',
            flowCode: 100020,
            children: [
              {
                name: '回访电话未接通',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['UNOPERATING', '回访电话未接通']
              },
              {
                name: '未完成',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['UNOPERATING', '回访电话未完成']
              },
              {
                name: '已回访',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['NEXTSTEP', '已回访']
              },
              {
                name: '发起客诉子任务',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'onCreateTask',
                methodParams: []
              }
            ]
          },
          {
            permName: '初审:回访并通知邮寄材料:邮件结果',
            flowCode: 100025,
            children: [
              {
                name: '收到材料',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['NEXTSTEP', '收到材料']
              }
            ]
          },
          {
            permName: '初审:纸质材料处理',
            flowCode: 100030,
            children: [
              {
                name: '已扫描上传存档',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['NEXTSTEP', '已扫描上传存档']
              }
            ]
          },
          {
            permName: '初审:核对材料:资料是否完整',
            flowCode: 100040,
            children: [
              {
                name: '资料未完整，邮件通知补交',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['CYCLE', '资料未完整，邮件通知补交', '', true]
              },
              {
                name: '资料合格完整',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['NEXTSTEP', '资料合格完整', '', false]
              }
            ]
          },
          {
            permName: '初审:核对材料:已收到资料',
            flowCode: 100045,
            children: [
              {
                name: '上一步',
                type: '',
                icon: 'el-icon-back',
                isHadPrevBtn: true,
                methodName: 'updateFlow',
                methodParams: ['PREVIOUSFLOW', '上一步']
              },
              {
                name: '已收到材料',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['NEXTSTEP', '已收到材料']
              }
            ]
          },
          {
            permName: '初审:审核补充资料',
            flowCode: 100055,
            children: [
              {
                name: '下一步',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['NEXTSTEP', '审核补充资料']
              }
            ]
          },
          {
            permName: '初审:审核补充资料',
            flowCode: 100057,
            children: [
              {
                name: '审核补充资料',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['NEXTSTEP', '审核补充资料', 'reportSupplementAssessNext']
              }
            ]
          },
          {
            permName: '初审:输出初审结果',
            flowCode: 100060,
            children: [
              {
                name: '下一步',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['NEXTSTEP', '输出初审结果']
              }
            ]
          }
        ],
        // 缴费
        1005: [
          {
            permName: '缴费:是否去调查',
            flowCode: 100599,
            children: [
              {
                name: '去调查',
                type: '',
                icon: '',
                methodName: 'updateFlow',
                methodParams: ['NEXTSTEP', '去调查']
              },
              {
                name: '回到审核补充材料',
                type: '',
                icon: '',
                methodName: 'showdrawerbox',
                methodParams: ['toRollFlow', '回到审核补充材料', 0]
              }
            ]
          },
          {
            permName: '缴费:邮件通知立案',
            flowCode: 100501,
            children: [
              {
                name: '上一步',
                type: '',
                icon: 'el-icon-back',
                isHadPrevBtn: true,
                methodName: 'updateFlow',
                methodParams: ['PREVIOUSFLOW', '上一步']
              },
              {
                name: '邮件通知立案',
                type: '',
                icon: '',
                methodName: 'updateFlow',
                methodParams: ['NEXTSTEP', '邮件通知立案']
              }
            ]
          },
          {
            permName: '缴费:已发邮件通知缴费',
            flowCode: 100510,
            children: [
              {
                name: '上一步',
                type: '',
                icon: 'el-icon-back',
                isHadPrevBtn: true,
                methodName: 'updateFlow',
                methodParams: ['PREVIOUSFLOW', '上一步']
              },
              {
                name: '已发邮件通知缴费',
                type: '',
                icon: '',
                methodName: 'updateFlow',
                methodParams: ['NEXTSTEP', '已发邮件通知缴费']
              }
            ]
          },
          {
            permName: '缴费:回访',
            flowCode: 100513,
            children: [
              {
                name: '回访电话未接通',
                type: '',
                icon: '',
                methodName: 'updateFlow',
                methodParams: ['UNOPERATING', '回访电话未接通']
              },
              {
                name: '未完成',
                type: '',
                icon: '',
                methodName: 'updateFlow',
                methodParams: ['UNOPERATING', '回访电话未完成']
              },
              {
                name: '已回访',
                type: '',
                icon: '',
                methodName: 'updateFlow',
                methodParams: ['NEXTSTEP', '已回访']
              },
              {
                name: '发起客诉子任务',
                type: '',
                icon: '',
                methodName: 'onCreateTask',
                methodParams: []
              }
            ]
          },
          {
            permName: '缴费:确认缴费',
            flowCode: 100515,
            children: [
              {
                name: '上一步',
                type: '',
                icon: 'el-icon-back',
                isHadPrevBtn: true,
                methodName: 'updateFlow',
                methodParams: ['PREVIOUSFLOW', '上一步']
              },
              {
                name: '已缴费',
                type: '',
                icon: 'el-icon-edit-outline',
                methodName: 'updateFlow',
                methodParams: ['NEXTSTEP', '已缴费']
              },
              {
                name: '拒绝缴费',
                type: '',
                icon: 'el-icon-edit-outline',
                methodName: 'showdrawerbox',
                methodParams: ['toRollFlow', '拒绝缴费', 0]
              }
            ]
          },
          {
            permName: '缴费:修改不予互助时间',
            flowCode: 100520,
            children: [
              {
                name: '修改不予互助时间',
                type: '',
                icon: '',
                methodName: 'updateDeadlineTime',
                methodParams: []
              },
              {
                name: '不予互助',
                type: '',
                icon: '',
                methodName: 'updateFlow',
                methodParams: ['REFUSAL', '不予互助']
              }
            ]
          }
        ],
        // 公估
        1010: [
          {
            permName: '公估:委派公估',
            flowCode: 101005,
            children: [
              {
                name: '上一步',
                type: '',
                icon: 'el-icon-back',
                isHadPrevBtn: true,
                methodName: 'updateFlow',
                methodParams: ['PREVIOUSFLOW', '上一步']
              },
              {
                name: '填写委派信息',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'showdrawerbox',
                methodParams: ['delegatedInfo']
              }
            ]
          },
          {
            permName: '公估:接单确认',
            flowCode: 101010,
            children: [
              {
                name: '上一步',
                type: '',
                icon: 'el-icon-back',
                isHadPrevBtn: true,
                methodName: 'updateFlow',
                methodParams: ['PREVIOUSFLOW', '上一步']
              },
              {
                name: '已经有调查人员接单',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['NEXTSTEP', '已经有调查人员接单']
              },
              {
                name: '接单超时，重新委派公估',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['OVERTIME_RETURN', '接单超时，重新委派公估']
              }
            ]
          },
          {
            permName: '公估:回访',
            flowCode: 101015,
            children: [
              {
                name: '上一步',
                type: '',
                icon: 'el-icon-back',
                isHadPrevBtn: true,
                methodName: 'updateFlow',
                methodParams: ['PREVIOUSFLOW', '上一步']
              },
              {
                name: '回访电话未接通',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['UNOPERATING', '回访电话未接通']
              },
              {
                name: '未完成',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['UNOPERATING', '回访电话未完成']
              },
              {
                name: '已回访',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['NEXTSTEP', '已回访']
              }
            ]
          },
          {
            permName: '公估:上传公估结果',
            flowCode: 101020,
            children: [
              {
                name: '上一步',
                type: '',
                icon: 'el-icon-back',
                isHadPrevBtn: true,
                methodName: 'updateFlow',
                methodParams: ['PREVIOUSFLOW', '上一步']
              },
              {
                name: '公估调查结果已上传',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['NEXTSTEP', '公估调查结果已上传']
              },
              {
                name: '退回重新调查',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'showdrawerbox',
                methodParams: ['toRollFlow', '退回重新调查', 0]
              }
            ]
          }
        ],
        // 复审
        1015: [
          {
            permName: '复审:事件内容评估',
            flowCode: 101501,
            children: [
              {
                name: '下一步',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['NEXTSTEP', '复审事件内容评估']
              }
            ]
          },
          {
            permName: '复审:审核公估调查内容',
            flowCode: 101505,
            children: [
              {
                name: '请说明公估结果',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'showdrawerbox',
                methodParams: ['investigation']
              }
            ]
          },
          {
            permName: '复审:通知并查收补充资料:通知补充材料',
            flowCode: 101515,
            children: [
              {
                name: '资料未完整，通知补充材料',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['NEXTSTEP', '复审:资料未完整，通知补充材料']
              }
            ]
          },
          {
            permName: '复审:通知并查收补充资料:已收到材料',
            flowCode: 101520,
            children: [
              {
                name: '已收到材料',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['NEXTSTEP', '已收到材料']
              }
            ]
          },
          {
            permName: '复审:通知并查收补充资料:资料完整性',
            flowCode: 101525,
            children: [
              {
                name: '资料完整',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['NEXTSTEP', '资料完整']
              },
              {
                name: '资料未完整',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['CYCLE', '资料未完整']
              }
            ]
          },
          {
            permName: '复审:说明公估结果',
            flowCode: 101530,
            children: [
              {
                name: '无需补充材料',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['NEXTSTEP', '复审无需补充材料']
              }
            ]
          },
          {
            permName: '复审:输出复审结果',
            flowCode: 101535,
            children: [
              {
                name: '下一步',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['NEXTSTEP', '复审输出复审结果']
              }
            ]
          },
          {
            permName: '复审:合议',
            flowCode: 101540,
            children: [
              {
                name: '保存',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'saveCollegiateResult',
                methodParams: []
              }
            ]
          },
          {
            permName: '复审:审批',
            flowCode: 101550,
            children: [
              {
                name: '通过',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['NEXTSTEP', '通过']
              },
              {
                name: '退回到复审结果',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'showdrawerbox',
                methodParams: ['toRollFlow', '审批退回到复审结果', 0]
              }
            ]
          },
          {
            permName: '复审:三审',
            flowCode: 101560,
            children: [
              {
                name: '下一步',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['NEXTSTEP', '通过']
              }
            ]
          },
          {
            permName: '案件:修改案件锁定状态',
            flowCode: 101560,
            children: [
              {
                name: '设为低度协谈',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                isLowerDegreeCommunicateStatus: true, // 沟通情况判断
                methodName: 'updateCaseLock',
                methodParams: [true]
              }
            ]
          },
          {
            permName: '案件:修改案件锁定状态',
            flowCode: 101560,
            children: [
              {
                name: '取消低度协谈',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                isLowerDegreeCommunicateStatus: true, // 沟通情况判断
                methodName: 'updateCaseLock',
                methodParams: [false]
              }
            ]
          },
          {
            permName: '复审:已审批',
            flowCode: 101570,
            children: [
              {
                name: '已审批',
                type: '',
                icon: '',
                methodName: 'updateFlow',
                methodParams: ['NEXTSTEP', '已审批']
              }
            ]
          }
        ],
        // 交叉审
        1017: [
          {
            permName: '交叉审:事件内容评估',
            flowCode: 101701,
            children: [
              {
                name: '上一步',
                type: '',
                icon: 'el-icon-back',
                isHadPrevBtn: true,
                methodName: 'updateFlow',
                methodParams: ['PREVIOUSFLOW', '上一步']
              },
              {
                name: '请评估',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'showdrawerbox',
                methodParams: ['contentAssessment']
              }
            ]
          },
          {
            permName: '交叉审:审核公估调查内容',
            flowCode: 101705,
            children: [
              {
                name: '上一步',
                type: '',
                icon: 'el-icon-back',
                isHadPrevBtn: true,
                methodName: 'updateFlow',
                methodParams: ['PREVIOUSFLOW', '上一步']
              },
              {
                name: '请说明公估结果',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'showdrawerbox',
                methodParams: ['investigation']
              }
            ]
          },
          {
            permName: '交叉审:通知并查收补充资料:邮件通知补交',
            flowCode: 101715,
            children: [
              {
                name: '上一步',
                type: '',
                icon: 'el-icon-back',
                isHadPrevBtn: true,
                methodName: 'updateFlow',
                methodParams: ['PREVIOUSFLOW', '上一步']
              },
              {
                name: '资料未完整，通知补充材料',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['NEXTSTEP', '资料未完整，通知补充材料']
              }
            ]
          },
          {
            permName: '交叉审:通知并查收补充资料:已收到材料',
            flowCode: 101720,
            children: [
              {
                name: '上一步',
                type: '',
                icon: 'el-icon-back',
                isHadPrevBtn: true,
                methodName: 'updateFlow',
                methodParams: ['PREVIOUSFLOW', '上一步']
              },
              {
                name: '已收到材料',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['NEXTSTEP', '已收到材料']
              }
            ]
          },
          {
            permName: '交叉审:通知并查收补充资料:修改不予互助时间',
            flowCode: 101722,
            children: [
              {
                name: '修改不予互助时间',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateDeadlineTime',
                methodParams: []
              },
              {
                name: '不予互助',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['REFUSAL', '不予互助']
              }
            ]
          },
          {
            permName: '交叉审:通知并查收补充资料:资料完整性',
            flowCode: 101725,
            children: [
              {
                name: '上一步',
                type: '',
                icon: 'el-icon-back',
                isHadPrevBtn: true,
                methodName: 'updateFlow',
                methodParams: ['PREVIOUSFLOW', '上一步']
              },
              {
                name: '资料完整',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['NEXTSTEP', '资料完整']
              },
              {
                name: '资料未完整',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['CYCLE', '资料未完整']
              }
            ]
          },
          {
            permName: '交叉审:说明公估结果',
            flowCode: 101730,
            children: [
              {
                name: '上一步',
                type: '',
                icon: 'el-icon-back',
                isHadPrevBtn: true,
                methodName: 'updateFlow',
                methodParams: ['PREVIOUSFLOW', '上一步']
              },
              {
                name: '无需补充材料',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['NEXTSTEP', '无需补充材料']
              }
            ]
          },
          {
            permName: '交叉审:输出复审结果',
            flowCode: 101735,
            children: [
              {
                name: '上一步',
                type: '',
                icon: 'el-icon-back',
                isHadPrevBtn: true,
                methodName: 'updateFlow',
                methodParams: ['PREVIOUSFLOW', '上一步']
              },
              {
                name: '审核通过',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['NEXTSTEP', '审核通过']
              },
              {
                name: '撤案',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['WITHDRAWAL', '撤案']
              },
              {
                name: '不予互助',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['REFUSAL', '不予互助']
              },
              {
                name: '申请合议',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['APPLICATION_COLLEGIATE', '申请合议']
              }
            ]
          },
          {
            permName: '交叉审:合议',
            flowCode: 101740,
            children: [
              {
                name: '保存',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['NEXTSTEP', '交叉审，合议保存']
              }
            ]
          }
        ],
        // 待公示
        1020: [
          {
            permName: '待公示:退回',
            flowCode: 102001,
            children: [
              {
                name: '退回',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['CASEGOBACK', '退回']
              }
            ]
          },
          {
            permName: '待公示:邮件告知用户',
            flowCode: 102001,
            children: [
              {
                name: '已发邮件通知会员提交相关资料',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['NEXTSTEP', '已发邮件通知会员提交相关资料']
              }
            ]
          },
          {
            permName: '待公示:退回',
            flowCode: 102005,
            children: [
              {
                name: '退回',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['CASEGOBACK', '退回']
              }
            ]
          },
          {
            permName: '待公示:确认已缴费:缴费结果',
            flowCode: 102005,
            children: [
              {
                name: '会员已缴费',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['NEXTSTEP', '会员已缴费']
              },
              {
                name: '挂起，会员未缴费',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['UNOPERATING', '挂起，会员未缴费']
              }
            ]
          },
          {
            permName: '待公示:确认已缴费:修改不予互助时间',
            flowCode: 102007,
            children: [
              {
                name: '修改不予互助时间',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateDeadlineTime',
                methodParams: []
              },
              {
                name: '不予互助',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['REFUSAL', '不予互助']
              }
            ]
          },
          {
            permName: '待公示:退回',
            flowCode: 102010,
            children: [
              {
                name: '退回',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['CASEGOBACK', '退回']
              }
            ]
          },
          {
            permName: '待公示:查收公证材料',
            flowCode: 102010,
            children: [
              {
                name: '上一步',
                type: '',
                icon: 'el-icon-back',
                isHadPrevBtn: true,
                methodName: 'updateFlow',
                methodParams: ['PREVIOUSFLOW', '上一步']
              },
              {
                name: '公证材料已收齐',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['NEXTSTEP', '公证材料已收齐']
              },
              {
                name: '会员健在，无需提供',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['NEXTSTEP', '会员健在，无需提供']
              }
            ]
          },
          {
            permName: '待公示:退回',
            flowCode: 102020,
            children: [
              {
                name: '退回',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['CASEGOBACK', '退回']
              }
            ]
          },
          {
            permName: '待公示:核对银行账号:信息完整',
            flowCode: 102020,
            children: [
              {
                name: '上一步',
                type: '',
                icon: 'el-icon-back',
                isHadPrevBtn: true,
                methodName: 'updateFlow',
                methodParams: ['PREVIOUSFLOW', '上一步']
              },
              {
                name: '信息正确',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['NEXTSTEP', '信息正确']
              },
              {
                name: '信息有误，需要更正',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['CYCLE', '信息有误，需要更正']
              }
            ]
          },
          {
            permName: '待公示:退回',
            flowCode: 102025,
            children: [
              {
                name: '退回',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['CASEGOBACK', '退回']
              }
            ]
          },
          {
            permName: '待公示:核对银行账号:信息更正',
            flowCode: 102025,
            children: [
              {
                name: '上一步',
                type: '',
                icon: 'el-icon-back',
                isHadPrevBtn: true,
                methodName: 'updateFlow',
                methodParams: ['PREVIOUSFLOW', '上一步']
              },
              {
                name: '信息已更正',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['NEXTSTEP', '信息已更正']
              }
            ]
          },
          {
            permName: '待公示:退回',
            flowCode: 102030,
            children: [
              {
                name: '退回',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['CASEGOBACK', '退回']
              }
            ]
          },
          {
            permName: '待公示:回收调查意见表',
            flowCode: 102030,
            children: [
              {
                name: '上一步',
                type: '',
                icon: 'el-icon-back',
                isHadPrevBtn: true,
                methodName: 'updateFlow',
                methodParams: ['PREVIOUSFLOW', '上一步']
              },
              {
                name: '意见表已查收',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['NEXTSTEP', '意见表已查收']
              }
            ]
          },
          {
            permName: '待公示:退回',
            flowCode: 102035,
            children: [
              {
                name: '退回',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['CASEGOBACK', '退回']
              }
            ]
          },
          {
            permName: '待公示:确认已完成助力',
            flowCode: 102035,
            children: [
              {
                name: '上一步',
                type: '',
                icon: 'el-icon-back',
                isHadPrevBtn: true,
                methodName: 'updateFlow',
                methodParams: ['PREVIOUSFLOW', '上一步']
              },
              {
                name: '已完成助力活动',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['NEXTSTEP', '已完成助力活动']
              },
              {
                name: '挂起，等待完成助力活动',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['UNOPERATING', '挂起，等待完成助力活动']
              }
            ]
          },
          {
            permName: '',
            flowCode: 102070,
            children: [
              {
                name: '下一步',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['NEXTSTEP', '进入业管端']
              }
            ]
          }
        ],
        // 可公示
        1025: [
          {
            permName: '可公示:邮件通知用户进入公示期',
            flowCode: 102501,
            children: [
              {
                name: '已完成',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['NEXTSTEP', '已完成']
              }
            ]
          },
          {
            permName: '可公示:扣款',
            flowCode: 102505,
            children: [
              {
                name: '上一步',
                type: '',
                icon: 'el-icon-back',
                isHadPrevBtn: true,
                methodName: 'updateFlow',
                methodParams: ['PREVIOUSFLOW', '上一步']
              },
              {
                name: '已完成',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['NEXTSTEP', '已完成']
              }
            ]
          },
          {
            permName: '可公示:收取收据',
            flowCode: 102510,
            children: [
              {
                name: '上一步',
                type: '',
                icon: 'el-icon-back',
                isHadPrevBtn: true,
                methodName: 'updateFlow',
                methodParams: ['PREVIOUSFLOW', '上一步']
              },
              {
                name: '已完成',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['NEXTSTEP', '已完成']
              }
            ]
          }
        ],
        // 待归档
        1030: [
          // 待归档：确认结果（待归档）
          {
            permName: '待归档:确认结果',
            flowCode: 103001,
            children: [
              {
                name: '重新审核',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['CASEGOBACK', '重新审核']
              },
              {
                name: '已发邮件通知会员审核结果',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                isProcessResultEnum: true, // 过程结果枚举
                methodName: 'updateFlow',
                methodParams: ['NEXTSTEP', '已发邮件通知会员审核结果']
              },
              {
                name: '发起客诉子任务',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'onCreateTask',
                methodParams: []
              }
            ]
          },
          // 待归档：合议
          {
            permName: '待归档:退回',
            flowCode: 103050,
            children: [
              {
                name: '去法务',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                methodName: 'updateFlow',
                methodParams: ['NEXTSTEP', '去法务']
              }
            ]
          }
        ],
        // 归档(只有不予互助的才能重新发起)
        1035: [
          {
            permName: '归档:归档',
            flowCode: 103501,
            children: [
              {
                name: '退回到合议',
                type: '',
                icon: '',
                isHadPrevBtn: false,
                isProcessResultEnum: true, // 过程结果枚举
                methodName: 'updateFlow',
                methodParams: ['RESTARTCASE', '重新发起']
              }
            ]
          }
        ]
      },

      // 当前时间日期选择器特有的选项（计算今天、昨天以及一周前的日期）
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date())
            }
          },
          {
            text: '昨天',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', date)
            }
          },
          {
            text: '一周前',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', date)
            }
          }
        ]
      }
    }
  },

  computed: {
    ...mapState({
      caseInfo: (state) => state.caseDetail.caseInfo,
      permList: (state) => state.permission.permList
    }),

    /**
     * 获取页面URL中的来源标记
     */
    currentfrom() {
      return this.$route.query.from
    },

    /**
     * 判断当前流程是否需要显示时间选择器（不予互助时间）
     */
    isPickerBlock() {
      const {
        permList,
        checkPermission,
        caseInfo: { flowCode }
      } = this

      if (
        (checkPermission('缴费:修改不予互助时间', permList) && flowCode === 100520) ||
        (checkPermission('交叉审:通知并查收补充资料:修改不予互助时间', permList) &&
          flowCode === 101722) ||
        (checkPermission('待公示:确认已缴费:修改不予互助时间', permList) &&
          flowCode === 102007)
      ) {
        return true
      } else {
        return false
      }
    },

    /**
     * 判断当前流程是否需要显示退回说明输入框
     */
    isBackRemarkInput() {
      const {
        permList,
        checkPermission,
        caseInfo: { flowCode }
      } = this

      if (
        (checkPermission('待公示:退回', permList) &&
          (flowCode === 102001 ||
            flowCode === 102005 ||
            flowCode === 102010 ||
            flowCode === 102020 ||
            flowCode === 102025 ||
            flowCode === 102030 ||
            flowCode === 102035)) ||
        (checkPermission('待归档:确认结果', permList) && flowCode === 103001)
      ) {
        return true
      } else {
        return false
      }
    }
  },

  // 侦听器
  watch: {
    // 监听案件详情数据是否有变化
    caseInfo() {
      const { sendTimeStr, endTimeStr } = this.caseInfo
      if (sendTimeStr !== undefined) {
        this.startDeadlineTime = sendTimeStr
      }
      if (endTimeStr !== undefined) {
        this.endDeadlineTime = endTimeStr
      }

      this.getCurrentStepsList()
      this.getOperationBtnList()
    }
  },

  created() {
    this.getCurrentStepsList()
    this.getOperationBtnList()
  },

  methods: {
    /**
     * 获取当前案件的步骤列表
     */
    getCurrentStepsList() {
      let newList = []
      const stepsList = [] // 当前步骤列表
      let stepsActiveIndex = 0 // 记录当前已完成的步骤下标值
      const {
        allStepsList,
        caseInfo: { flowCode, processResultEnum }
      } = this
      let signKey = 0 // 标识

      // 遍历全部流程列表，查询出当前案件的步骤列表
      Object.keys(allStepsList).forEach((key) => {
        if (String(flowCode).indexOf(key) === 0) {
          newList = allStepsList[key]
          signKey = key
        }
      })

      // 遍历步骤列表，判断步骤是否已执行
      newList &&
        newList.forEach((item, index) => {
          // 当前步骤需要单独判断标识
          if (item.judge) {
            if (item.flowCode === '103001') {
              if (processResultEnum === 'PROCESS' && item.title === '确认归档') {
                stepsList.push(item)
              } else if (
                processResultEnum !== 'PROCESS' &&
                item.title === '邮件告知用户结果'
              ) {
                stepsList.push(item)
              }
            } else if (item.flowCode === '103501' && processResultEnum !== 'PROCESS') {
              stepsList.push(item)
            }
          } else {
            stepsList.push(item)
          }

          if (parseInt(signKey) === 1005) {
            // 特殊流程-特殊处理
            // 缴费流程
            if (flowCode < 100599 && flowCode >= item.flowCode) {
              stepsActiveIndex = index + 1
            } else if (flowCode <= item.flowCode && !stepsActiveIndex) {
              stepsActiveIndex = index + 1
            }
          } else {
            if (item.flowCode <= flowCode) {
              stepsActiveIndex = index + 1
            }
          }
        })

      this.stepsList = stepsList
      this.stepsActiveIndex = stepsActiveIndex
    },

    /**
     * 获取当前案件的操作按钮列表
     */
    getOperationBtnList() {
      const listData = []
      let btnList = []
      const {
        permList,
        allOperationBtnList,
        checkPermission,
        caseInfo: {
          flowCode,
          hadPrevButton,
          lowerDegreeCommunicateStatus,
          processResultEnum
        }
      } = this

      // 遍历全部流程列表，查询出当前案件的步骤列表
      Object.keys(allOperationBtnList).forEach((key) => {
        if (String(flowCode).indexOf(key) === 0) {
          btnList = allOperationBtnList[key]
        }
      })

      // 遍历所有操作按钮列表，查询当前按钮流程对应显示的列表
      btnList &&
        btnList.forEach((item) => {
          // 检查权限
          const isCheckPermission = item.permName
            ? checkPermission(item.permName, permList)
            : true

          if (isCheckPermission && item.flowCode === flowCode) {
            item.children &&
              item.children.forEach((zItem) => {
                if (zItem.isHadPrevBtn) {
                  // 判断当前流程是否应显示上一页按钮
                  if (hadPrevButton) listData.push(zItem)
                } else if (zItem.isLowerDegreeCommunicateStatus) {
                  // 判断“案件:修改案件锁定状态”的按钮显示
                  if (!lowerDegreeCommunicateStatus && zItem.name === '设为低度协谈') {
                    listData.push(zItem)
                  } else if (
                    lowerDegreeCommunicateStatus &&
                    zItem.name === '取消低度协谈'
                  ) {
                    listData.push(zItem)
                  }
                } else if (zItem.isProcessResultEnum) {
                  // 过程结果枚举
                  if (processResultEnum !== 'PROCESS') {
                    listData.push(zItem)
                  }
                } else {
                  listData.push(zItem)
                }
              })
          }
        })

      this.operationBtnList = JSON.parse(JSON.stringify(listData))
    },

    /**
     * 触发案件的操作按钮方法
     */
    onOperationBtnMethod(methodName, methodParams) {
      const params = JSON.parse(JSON.stringify(methodParams))
      const { operateEnums } = this

      if (methodName === 'updateDeadlineTime') {
        this.updateDeadlineTime()
      } else if (methodName === 'updateFlow') {
        params[0] = operateEnums[params[0]]
        this.updateFlow(...params)
      } else if (methodName === 'showdrawerbox') {
        this.showdrawerbox(...params)
      } else if (methodName === 'updateCaseLock') {
        this.updateCaseLock(...params)
      } else if (methodName === 'onCreateTask') {
        this.onCreateTask()
      }
    },

    /**
     * 更新超时不予互助时间
     */
    async updateDeadlineTime() {
      const _this = this
      const {
        endDeadlineTime,
        caseInfo: { caseCode }
      } = _this
      // 接口参数
      const deadlineTimeInfo = {
        caseCode,
        endTime: endDeadlineTime
      }

      try {
        const { data: result } = await _this.axios({
          url: `/casesCommon/deadlineTime`,
          method: 'put',
          data: JSON.stringify(deadlineTimeInfo),
          headers: {
            'Content-type': 'application/json'
          }
        })
        if (result && result.status === '000000') {
          _this.$alert('操作成功', '提示')
        } else {
          _this.$alert(result && result.message, '提示')
        }
      } catch (error) {
        console.log('更新超时不予互助时间-请求失败', error)
      }
    },

    /**
     * 显示抽屉盒
     */
    showdrawerbox(type, buttonName, caseStatus) {
      this.$emit('showdrawerbox', type, buttonName, caseStatus + '')
    },

    /**
     * 更新流程
     * @param {string} code 按钮类型
     * @param {string} msg 按钮说明
     * @param {string} type 表单类型
     * @param {string} isMiss 忽略不用发邮件操作
     */
    async updateFlow(code, msg, type, isMiss) {
      const _this = this
      const {
        answerRuleResult,
        caseInfo: { caseCode }
      } = _this

      // 更新流程（点击上一步、下一步按钮）
      // 如果当前是正常通过，即判断当前是否要弹出右边框
      if (answerRuleResult.code === 0) {
        if (type === 'reportSupplementAssessNext') {
          _this.showdrawerbox('reportSupplementAssessNext')
          return false
        } else if (type === 'investigation') {
          _this.showdrawerbox('investigation')
          return false
        }
      }

      // 如果当前
      // isMiss 有些流程的按钮是一定不用发邮件的，比如【初审:核对材料:资料是否完整】的【资料合格完整】
      const req = {
        answerJson: isMiss === undefined || isMiss === true ? 101 : 0,
        caseCode
      }
      // 当前操作是撤案或者不予互助的话
      if (code === 1 || code === 2) {
        req.answerJson = code
      }

      // 公估-接单确认-已经有调查人员接单，操作前的提示
      if (msg === '已经有调查人员接单') {
        const { publicAssessment } = _this.caseInfo
        const { listDetail: { delegatedName }} = JSON.parse(publicAssessment)
        const confirm = await _this.$confirm(`即将生成经办人为${delegatedName}的公估公司/个人子任务，请确认是否生成？`, '提示')

        if (confirm !== 'confirm') return false
      }

      try {
        const { data: result } = await _this.axios.post(`/flow-mail/mails`, req)
        if (result && result.status === '000000') {
          // const cases = _this.cases;
          const respEmailList = result.data
          // 如果有邮件模板
          if (respEmailList !== undefined && respEmailList.length > 0) {
            const emailTab = []
            respEmailList.forEach((emailItem) => {
              const templateType = emailItem.templateType.substring(4, 6)
              emailTab.push('tab' + templateType)
            })

            _this.emailDialog = true
            _this.showEmailTab = emailTab
            _this.showEmailMsg = msg
            _this.showEmailCode = code
            _this.showButton = false
          } else {
            _this.updateCaseFlow(code, msg)
          }
        } else {
          _this.$alert((result && result.message) || '服务器繁忙，请稍后重试', '提示')
        }
      } catch (error) {
        console.log('更新流程-请求失败', error)
      }
    },

    /**
     * 更新流程（点击上一步、下一步按钮）
     * @param {string} code 按钮类型
     * @param {string} msg 按钮说明
     */
    updateCaseFlow(code, msg) {
      const _this = this

      _this
        .$confirm('确定要进行' + msg + '操作吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          _this.fetchCaseNextStep(code, msg)
        })
        .catch(() => {})
    },

    /**
     * 案件的下一步
     * @param {string} code 按钮类型
     * @param {string} msg 按钮说明
     */
    async fetchCaseNextStep(code, msg) {
      const _this = this
      const { backRemark } = _this
      const { infoVersion, caseCode } = _this.caseInfo
      const updateObj = {
        version: infoVersion,
        caseCode,
        remark: backRemark,
        menuCode: code,
        buttonName: msg
      }

      try {
        const { data: result } = await _this.axios({
          url: `/casesCommon/caseNextStep`,
          method: 'put',
          data: JSON.stringify(updateObj),
          headers: {
            'Content-type': 'application/json'
          }
        })

        if (result && result.status === '000000') {
          // 注意：因为某些流程会存在多流程时效信息，这时候如果立刻去请求接口，可能获取不到相关信息，则需要等待2秒后再去请求
          _this.getCaseInfo(2000)
          _this.fullscreenLoading = true
          _this.$alert('操作成功', '提示', {
            callback: () => {
              _this.emailDialog = false
            }
          })
        } else {
          _this.$alert((result && result.message) || '服务器繁忙，请稍后重试', '提示')
        }
      } catch (error) {
        console.log('案件的下一步-请求失败', error)
      }
    },

    /**
     * 更新任务
     * @param {string} code 按钮类型
     * @param {string} msg 按钮说明
     */
    updateTask(code, msg) {
      const _this = this

      _this
        .$confirm(`确定要进行${msg}操作吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          _this.fetchCaseTaskHandle(code)
        })
        .catch(() => {})
    },

    /**
     * 子任务-处理任务
     * @param {string} code 按钮类型
     */
    async fetchCaseTaskHandle(code) {
      const _this = this
      const {
        taskCode,
        taskVersion,
        caseInfo: { caseCode }
      } = _this

      // 请求参数
      const updateObj = {
        caseCode,
        handleTask: code,
        taskCode,
        taskVersion
      }

      try {
        const { data: result } = await _this.axios({
          url: `/case-task/handle`,
          method: 'post',
          data: JSON.stringify(updateObj),
          headers: {
            'Content-type': 'application/json'
          }
        })

        if (result && result.status === '000000') {
          const { currentfrom } = _this
          let path = ''
          if (currentfrom === 'task') { // 全部任务
            path = '/index/task'
          } else if (currentfrom === 'mytask') { // 我的任务
            path = '/index/mytask'
          } else if (currentfrom === 'myResearchTask') { // 我的调查任务
            path = '/index/myResearchTask'
          }

          if (path) {
            _this.$alert('操作成功', '提示', {
              callback: () => {
                _this.$router.push({ path })
              }
            })
          }
        } else {
          _this.$alert((result && result.message) || '服务器繁忙，请稍后重试', '提示')
        }
      } catch (error) {
        console.log('子任务-处理任务-请求失败', error)
      }
    },

    /**
     * 修改案件锁定状态
     * @param doLockFlag {Boolean} true：锁定 false：解除锁定
     */
    async updateCaseLock(doLockFlag) {
      const _this = this
      const {
        caseInfo: { caseCode, detailVersion }
      } = _this

      // 请求参数
      const params = {
        caseCode,
        caseLockStatus: 1,
        detailVersion,
        doLockFlag
      }
      try {
        const { data: result } = await _this.axios.post(`/case-lock/update`, params)
        if (result && result.status === '000000') {
          if (!doLockFlag) {
            _this.$alert('取消低度协谈标识成功，请再次确认互助标准', '提示')
          }
          _this.getCaseInfo()
        } else {
          _this.$alert((result && result.message) || '服务器繁忙，请稍后重试', '提示')
        }
      } catch (error) {
        console.log('修改案件锁定状态-请求失败', error)
      }
    },

    /**
     * 创建子任务
     */
    async onCreateTask() {
      const _this = this
      const {
        caseInfo: { caseCode }
      } = _this

      try {
        const { data: result } = await _this.axios.get(
          `/dispatch-case/createTask/${caseCode}`
        )
        if (result && result.status === '000000') {
          _this.$alert('发起客诉子任务成功', '提示')
        } else {
          _this.$alert((result && result.message) || '服务器繁忙，请稍后重试', '提示')
        }
        _this.$emit('getCaseOperationList') // 刷新历史操作记录
      } catch (error) {
        console.log('创建子任务-请求失败', error)
      }
    },

    /**
     * 通知父级组件-获取案件详情数据
     */
    getCaseInfo(countdown = 0) {
      setTimeout(() => {
        this.fullscreenLoading = false
        this.$emit('getcaseInfo')
      }, countdown)
    }
  }
}
</script>

<style scoped lang="scss">
.button-block {
  margin-top: 10px;
}

.marginTop20 {
  margin-top: 20px;
}

.bold {
  font-weight: bold;
}
</style>
